import { useContext } from 'react';
import provideActivityLink from '@/components/provide-activity-link';

export default function useActivityLink() {
  return useContext(provideActivityLink.context);
}
